import './lncanada5/style';
import FormStructure from './lncanada5/form_structure';

export default FormStructure;